// carousel.js

var $ = require('jquery');
var slick = require('slick-carousel');

$(document).ready(function() {
	
	if ($(".editor-styles-wrapper").length > 1) {
		return;
	}

	var options = {};

	$(".carousel").slick({
	  dots: false,
	//   arrows: false,
	  draggable: false,
	//   pauseOnHover: false,
	  infinite: false,
	//   centerMode: true,
	//   autoplay: true,
	//   variableWidth: true,
	//   speed: 6000,
	//   autoplaySpeed: 0,
	//   cssEase: 'linear',
	//   slidesToShow: 3,
	//   slidesToScroll: 1
	});
})
